module.exports = __webpack_public_path__ + "img/perimeter.8ea2465f.svg";